import { useMutation } from '@tanstack/react-query';

import OpenNotification from 'src/app/components/antd/OpenNotification';
import { createUpsellFlow as createUpsellFlowApi } from 'src/service/api/upsellFlow';

export function useAddUpsellFlow() {
  const {
    mutate,
    isPending: isLoading,
    isSuccess,
  } = useMutation({
    mutationFn: createUpsellFlowApi,
    onError: () => {
      OpenNotification(true, 'Erro ao cadastrar o fluxo');
    },
  });

  return { createNewUpsellFlow: mutate, isLoading, isSuccess };
}
